import {
  FaBuilding,
  FaEnvelope,
  FaExpand,
  FaPlug,
  FaMapMarkerAlt,
  FaPhoneAlt,
} from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";

import images from "./images";

const venue = {
  googleMap: {
    src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s",
    allowFullScreen: true,
    loading: "lazy",
  },

  venueInfo: {
    sub: "Explore Our Venue",
    heading: "Venue Overview",
    points: [
      {
        icon: <FaBuilding />,
        title: "Venue Name",
        description: "Summit Convention Center",
      },
      {
        icon: <FaLocationDot />,
        title: "Venue Address",
        description:
          "456 Innovation Road, Central District\nTech Valley, San Francisco, CA 94107, USA",
      },
      {
        icon: <FaPhoneAlt />,
        title: "Contact Number",
        description: "+1-800-555-6789\n+1-800-123-4567",
      },
      {
        icon: <FaEnvelope />,
        title: "Email Address",
        description: "events@summitcenter.com\nsupport@summitcenter.com",
      },
    ],
  },

  venueGallery: [
    images.venueGallery1,
    images.venueGallery2,
    images.venueGallery3,
    images.venueGallery4,
  ],

  venueFeatures: [
    {
      icon: <FaExpand />,
      title: "Flexible Event Halls",
      desc: "Modular halls that adapt to conferences, workshops, and expos.",
    },
    {
      icon: <FaPlug />,
      title: "High-Speed Connectivity",
      desc: "Reliable internet and tech support for smooth presentations.",
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Central Location",
      desc: "Minutes away from airports, hotels, and key business districts.",
    },
    {
      icon: <FaExpand />,
      title: "Modern Design",
      desc: "Stylish interiors with comfortable seating and ambiance.",
    },
    {
      icon: <FaPlug />,
      title: "Power & AV Setup",
      desc: "All rooms equipped with AV systems, lighting, and charging ports.",
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Nearby Facilities",
      desc: "Access to cafes, lounges, and on-site catering options.",
    },
  ],
};

export default venue;